import React, { memo } from 'react';
import { EntryLinkValueView } from '../entry-link/entry-link-value-view.tsx';
import { type BacklinkReadContent } from './backlink-read-content.ts';

/**
 * Backlinks reuse V1 entry-pill geometry; number mode renders its literal count.
 */
export const BacklinkValueView = memo(function BacklinkValueView({
  content,
  noFocus = false,
  isMobile = false
}: {
  readonly content: BacklinkReadContent;
  readonly noFocus?: boolean;
  readonly isMobile?: boolean;
}) {
  if (
    content.message ||
    content.entries.loadingWidth !== undefined ||
    content.mode === 'link'
  ) {
    return (
      <EntryLinkValueView
        content={content.entries}
        noFocus={noFocus}
        isMobile={isMobile}
      />
    );
  }

  return <>{content.count}</>;
});
